<component-title  *ngIf="isAdaTheme && isEntitledforView" [portletTitle]="id"></component-title>
	<f2-component #f2 [class]="class"
		[id]="id" [entitlement]="entitlement" *ngIf="isEntitledforView" [attr.id]="id">
	</f2-component>
